/**
 * @generated SignedSource<<999b0c841b257b79b7d209ae9cefc2dc>>
 * @relayHash 90fc805b3506e3b990a2604703ff72e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d65fb5fe07d0e48119654fb0b35731caadd33c04de6b442a7ce98fbf8f4014eb

import type { ConcreteRequest, Query } from 'relay-runtime';
export type queryQuery$variables = {
  projectAri: string;
  updatedFrom?: AGG$DateTime | null | undefined;
};
export type queryQuery$data = {
  readonly devOps: {
    readonly ariGraph: {
      readonly branchRelationships: {
        readonly nodes: ReadonlyArray<{
          readonly __typename: "AriGraphRelationship";
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly buildRelationships: {
        readonly nodes: ReadonlyArray<{
          readonly __typename: "AriGraphRelationship";
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly prRelationships: {
        readonly nodes: ReadonlyArray<{
          readonly __typename: "AriGraphRelationship";
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type queryQuery = {
  response: queryQuery$data;
  variables: queryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "updatedFrom"
  }
],
v1 = {
  "kind": "Variable",
  "name": "from",
  "variableName": "projectAri"
},
v2 = {
  "kind": "Variable",
  "name": "updatedFrom",
  "variableName": "updatedFrom"
},
v3 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v4 = [
  {
    "concreteType": "AriGraphRelationship",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      }
    ]
  }
],
v5 = [
  {
    "concreteType": "DevOps",
    "kind": "LinkedField",
    "name": "devOps",
    "plural": false,
    "selections": [
      {
        "concreteType": "AriGraph",
        "kind": "LinkedField",
        "name": "ariGraph",
        "plural": false,
        "selections": [
          {
            "alias": "branchRelationships",
            "args": [
              {
                "fields": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "project-associated-branch"
                  },
                  (v2/*: any*/)
                ],
                "kind": "ObjectValue",
                "name": "filter"
              },
              (v3/*: any*/)
            ],
            "concreteType": "AriGraphRelationshipConnection",
            "kind": "LinkedField",
            "name": "relationships",
            "plural": false,
            "selections": (v4/*: any*/)
          },
          {
            "alias": "buildRelationships",
            "args": [
              {
                "fields": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "project-associated-build"
                  },
                  (v2/*: any*/)
                ],
                "kind": "ObjectValue",
                "name": "filter"
              },
              (v3/*: any*/)
            ],
            "concreteType": "AriGraphRelationshipConnection",
            "kind": "LinkedField",
            "name": "relationships",
            "plural": false,
            "selections": (v4/*: any*/)
          },
          {
            "alias": "prRelationships",
            "args": [
              {
                "fields": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "project-associated-pr"
                  },
                  (v2/*: any*/)
                ],
                "kind": "ObjectValue",
                "name": "filter"
              },
              (v3/*: any*/)
            ],
            "concreteType": "AriGraphRelationshipConnection",
            "kind": "LinkedField",
            "name": "relationships",
            "plural": false,
            "selections": (v4/*: any*/)
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "queryQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "queryQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "id": "d65fb5fe07d0e48119654fb0b35731caadd33c04de6b442a7ce98fbf8f4014eb",
    "metadata": {},
    "name": "queryQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3a0dda9ba85f56ef6287bdd6fcee818b";

export default node;
